module.exports = __webpack_public_path__ + "img/coaching.739e1c49.svg";